function Locations() {

  const branches = [
    {
      name: "Preschool - Branch 1",
      address: "Plot No 247/A, Saheed Nagar, Bhubaneswar, Odisha 751007",
      map: "https://www.google.com/maps?q=Bhubaneswar&output=embed"
    },
    {
      name: "Preschool - Branch 2",
      address: "Madhapur, Hyderabad, Telangana 500081",
      map: "https://www.google.com/maps?q=Madhapur%20Hyderabad&output=embed"
    },
    {
      name: "Preschool - Branch 3",
      address: "Gachibowli, Hyderabad, Telangana 500032",
      map: "https://www.google.com/maps?q=Gachibowli%20Hyderabad&output=embed"
    }
  ];

  return (
    <div className="max-w-7xl mx-auto px-6 py-12">

      <h1 className="text-3xl font-bold text-center mb-10">
        Our Branch Locations
      </h1>

      <div className="space-y-10">

        {branches.map((branch, index) => (
          <div
            key={index}
            className="grid md:grid-cols-2 gap-6 items-center bg-white shadow-md rounded-lg p-6"
          >

            {/* Left Side Address */}
            <div>
              <h2 className="text-xl font-semibold text-blue-700 mb-3">
                {branch.name}
              </h2>

              <p className="text-gray-600">
                {branch.address}
              </p>
            </div>

            {/* Right Side Map */}
            <div className="w-full h-64">

              <iframe
                src={branch.map}
                width="100%"
                height="100%"
                title="Branch location map"
                style={{ border: 0 }}
                loading="lazy"
                className="rounded-lg"
                allowFullScreen
              ></iframe>

            </div>

          </div>
        ))}

      </div>

    </div>
  );
}

export default Locations;